import { getAxiosClient } from "../../axios-client";
import { GetStorageAreaRequestBody, GetStorageAreaResponse } from "./types";

const axiosClient = getAxiosClient();
export const getStorageArea = async (id_magazyn: string | undefined) => {
  return await axiosClient.ax.post<GetStorageAreaResponse>("/StorageArea/Get", {
    id_magazyn,
  });
};
